<h1 mat-dialog-title>Are you sure you want to delete Income Verification form?</h1>

<div mat-dialog-content>

  <p>
    {{data}}
  </p>

</div>

<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-button
    style="margin-right: 9px;"
    (click)="onClickNo()">
    NO
  </button>
  <button mat-raised-button
    color="primary"
    (click)="onClickYes()">
    YES
  </button>
</div>